import { useFormContext } from 'react-hook-form';
import React from 'react';
import { DateRangeDropdownV2, SearchFieldV2 as SearchField, FormFieldV2 as FormField } from '@/components/custom/erp';
import { accountSearchColumns, QUERY_KEYS } from '@/constants';
import { Label } from '@/components/ui/label';

const ALLOWED_DEBT_ACCOUNT_CODE_PREFIXES = ['131', '138', '141', '244', '331', '338'];

const BasicInfoTab: React.FC = () => {
  const { setValue } = useFormContext();
  return (
    <div className='space-y-2 p-4'>
      <div className='flex flex-col space-y-3'>
        {/* Date Range Fields */}
        <div className='flex w-[60%] items-center'>
          <Label className='w-40 min-w-40'>Ngày từ/đến:</Label>
          <DateRangeDropdownV2
            fromDateName='ngay_tu'
            toDateName='ngay_den'
            toFieldClassName='w-40'
            fromFieldClassName='w-40'
          />
        </div>

        {/* Tài khoản */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Tài khoản</Label>
          <div className='w-[60%]'>
            <SearchField
              type='text'
              searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/filter_by_code/?tk=${ALLOWED_DEBT_ACCOUNT_CODE_PREFIXES}`}
              searchColumns={accountSearchColumns}
              dialogTitle='Danh mục tài khoản'
              columnDisplay='code'
              displayRelatedField='name'
              onValueChange={value => {
                setValue('tai_khoan', value);
              }}
              className='w-full'
              classNameRelatedField='w-auto min-w-[300px] max-w-full'
            />
          </div>
        </div>

        {/* Chi tiết theo vật tư */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Chi tiết theo vật tư</Label>
          <div className='w-64'>
            <FormField
              name='sap_xep_theo'
              type='select'
              options={[
                { value: 'ma_ncc', label: 'Có' },
                { value: 'so_du', label: 'Không' }
              ]}
              className='w-full'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
